import { useQuery } from '@apollo/client';
import Link from 'next/link';
import { nameFromCC, slugFromCC } from 'tf-post-parser';
import { GET_RECOMMENDED_POSTS } from '../../../helpers/graphql/posts';
import { fraunces } from '../../Landing/fonts';
import TrailPostCard from '../../Destinations/TrailPostCard';

// Static grid of recommended posts — replaces the carousel. Mount this
// lazily (e.g. inside LazyLoad) so the query only fires when scrolled near.
export default function RelatedPosts({
  countryCode,
  coordinates,
  community,
  currentPermlink,
}) {
  const { data, loading } = useQuery(GET_RECOMMENDED_POSTS, {
    variables: {
      language: community ? community.lang : undefined,
      countryCode,
      nearCoordinates: coordinates,
      minScore: 9000,
      limit: 7,
      community: community && !coordinates ? community.id : undefined,
      orderby: community && !coordinates ? 'random' : undefined,
    },
    ssr: false,
  });

  const posts = (data && data.posts ? data.posts : [])
    .filter(post => post.permlink !== currentPermlink && post.thumb)
    .slice(0, 6);

  if (!loading && posts.length === 0) return null;

  const countryName = countryCode ? nameFromCC(countryCode) : undefined;
  const slug = countryCode ? slugFromCC(countryCode) : undefined;

  return (
    <section className="tw-mx-auto tw-mb-16 tw-max-w-5xl tw-px-4">
      <div className="tw-mb-6 tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-2">
        <h2
          className={`${fraunces.className} tw-m-0 tw-text-2xl tw-font-semibold tw-tracking-tight tw-text-gray-900 dark:tw-text-gray-50 sm:tw-text-3xl`}
        >
          Keep exploring
        </h2>
        {countryName && (
          <Link
            href={`/destinations/${slug}`}
            prefetch={false}
            className="tw-text-sm tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300 tw-no-underline hover:tw-underline"
          >
            More from {countryName} →
          </Link>
        )}
      </div>
      <div className="tw-grid tw-grid-cols-1 tw-gap-x-6 tw-gap-y-8 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
        {loading && posts.length === 0
          ? [0, 1, 2].map(i => (
              <div key={i}>
                <div className="tw-aspect-[16/10] tw-animate-pulse tw-rounded-xl tw-bg-gray-300/40 dark:tw-bg-gray-600/30" />
                <div className="tw-mt-3 tw-h-4 tw-w-4/5 tw-animate-pulse tw-rounded tw-bg-gray-300/40 dark:tw-bg-gray-600/30" />
                <div className="tw-mt-2 tw-h-3 tw-w-2/5 tw-animate-pulse tw-rounded tw-bg-gray-300/40 dark:tw-bg-gray-600/30" />
              </div>
            ))
          : posts.map(post => (
              <TrailPostCard
                key={`${post.author.username}-${post.permlink}`}
                post={post}
              />
            ))}
      </div>
    </section>
  );
}
